import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRightContained01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M11.568 6.904a1 1 0 1 0-1.537 1.28l.768-.64zm2.767 4.883.768.64a1 1 0 0 0 0-1.28zm-4.304 3.603a1 1 0 1 0 1.537 1.28l-.769-.64zm.768-7.845-.768.64 3.536 4.242.768-.64.768-.64-3.535-4.243zm3.536 4.242-.768-.64-3.536 4.243.768.64.769.64 3.535-4.243zM12 2.4v1a8.6 8.6 0 0 1 8.6 8.6h2c0-5.854-4.746-10.6-10.6-10.6zm9.6 9.6h-1a8.6 8.6 0 0 1-8.6 8.6v2c5.854 0 10.6-4.746 10.6-10.6zM12 21.6v-1A8.6 8.6 0 0 1 3.4 12h-2c0 5.854 4.746 10.6 10.6 10.6zM2.4 12h1A8.6 8.6 0 0 1 12 3.4v-2C6.146 1.4 1.4 6.146 1.4 12z"
    />
  </svg>
);
export default SvgArrowRightContained01;
